import { render, staticRenderFns } from "./OutfitCommentModal.vue?vue&type=template&id=5f9afdba&scoped=true"
import script from "./OutfitCommentModal.vue?vue&type=script&lang=js"
export * from "./OutfitCommentModal.vue?vue&type=script&lang=js"
import style0 from "./OutfitCommentModal.vue?vue&type=style&index=0&id=5f9afdba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9afdba",
  null
  
)

export default component.exports